// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// <graphServiceSnippet1>
let graph = require('@microsoft/microsoft-graph-client');

function getAuthenticatedClient(accessToken: string) {
  // Initialize Graph client
  let client

      try{

        client = graph.Client.init({
          // Use the provided access token to authenticate
          // requests
          authProvider: (done: any) => {
            done(null, accessToken);
          }
        });
      } catch (e) {
        client = undefined
      }


  return client;
}

export async function getUserDetails(accessToken: string) {
  const client = getAuthenticatedClient(accessToken);
  let user;
  try{
   user = await client.api('/me').get();
  } catch (e)
  {
  
    user = undefined;
  }
  return user;
}


export async function getUserPhoto(accessToken: string) {
  const client = getAuthenticatedClient(accessToken);

  let photo ;
  
  try{
  photo = await client.api('/me/photo/$value').get();
  } catch(e)
  {
    photo = undefined;
  }
  return photo;
}
// </graphServiceSnippet1>

// <getEventsSnippet>
export async function getEvents(accessToken: string) {
  const client = getAuthenticatedClient(accessToken);

  let events ;

      try {
        events = await client
            .api('/me/events')
            .select('subject,organizer,start,end')
            .orderby('createdDateTime DESC')
            .get();
      } catch (e) {

        events = undefined
      }


  return events;
}
// </getEventsSnippet>
